import PermissionIssue from "../../components/permissionIssue";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../store/store";
import { LinearProgress } from "@mui/material";
import NotificationRulesComponent from "../../components/notificationRules";

const NotificationRulesPage = () => {
  const [isAllow, setIsAllow] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const { userData } = useAppSelector((state) => state.authReducer);

  useEffect(() => {
    if (userData) {
      setIsAllow(
        JSON.parse(
          userData.permission !== null ? userData.permission : "[]"
        ).includes("37")
      );
      setIsReady(true);
    }
  }, [userData]);

  return isReady ? (
    <>
      {isAllow || userData.group === "admin" ? (
        <NotificationRulesComponent />
      ) : (
        <PermissionIssue />
      )}
    </>
  ) : (
    <LinearProgress color="secondary" />
  );
};

export default NotificationRulesPage;
